export default __webpack_public_path__ + "static/media/cont6.dea959b9.jpeg";